<div class="descarte-modal descarte-tarefa">
  <div *ngIf="confirmarDescarte" class="confirm-content">
    <div class="confirm-icon-text">
      <img
        src="{{
          BASE_IMG_URL
        }}assets/img-ficha-obra/icone-deletar.png"
        alt=""
      />
      <span class="confirm-msg">Deseja realmente descartar esta tarefa?</span>
    </div>
    <div class="footer-actions-confirmar">
      <button
        class="btn btn-secondary me-2"
        type="button"
        (click)="onConfirmarDescarte(false)"
      >
        NÃO
      </button>
      <button
        class="btn btn-danger"
        type="button"
        (click)="onConfirmarDescarte(true)"
      >
        SIM, DESCARTAR
      </button>
    </div>
  </div>
  <div *ngIf="sucessoDescarteTarefa" class="form-content sucesso-content">
    <div class="sucesso-icon-text">
      <img
        src="{{
          BASE_IMG_URL
        }}assets/img-ficha-obra/concluido.png"
        alt=""
      />
      <span class="sucesso-msg">Tarefa descartada com sucesso!</span>
    </div>
    <div class="footer-actions-continuar">
      <button class="btn btn-primary" type="button" (click)="continuar()">
        CONTINUAR
      </button>
    </div>
  </div>
</div>
